"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/BlockListTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);








var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _phone = require('shared/services/phone');




var _smsDelivery = require('shared/services/smsDelivery');
var _noticeBar = require('web/services/context/noticeBar');
var _useUserNameOf = require('web/screens/Directory/hooks/useUserNameOf'); var _useUserNameOf2 = _interopRequireDefault(_useUserNameOf);

var _Form = require('web/components/Form');
var _SmsPreview = require('web/components/SmsPreview');
var _components = require('web/screens/Directory/TeamPage/components');
var _AddBlockModal = require('./AddBlockModal'); var _AddBlockModal2 = _interopRequireDefault(_AddBlockModal);
var _BlockedMessagesModal = require('./BlockedMessagesModal'); var _BlockedMessagesModal2 = _interopRequireDefault(_BlockedMessagesModal);






const formatLatestBlockedMessageAt = (receivedAt) => {
  if (!receivedAt) return ''
  const received = _moment2.default.call(void 0, receivedAt)
  return received.isValid() ? received.format('MM/DD/YYYY h:mm A') : ''
}

const getPatientName = (patient) =>
  patient.Name || [patient.FirstName, patient.LastName].filter(Boolean).join(' ')






const LinkedPatientCell = ({ orgKey, patients }) => {
  if (!patients.length) return _react2.default.createElement('span', { className: "team-page--block-list--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}, "No linked patient"  )
  if (patients.length > 1) return _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Multiple patients" )

  const patient = patients[0]
  if (!patient) return _react2.default.createElement('span', { className: "team-page--block-list--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "No linked patient"  )
  return (
    _react2.default.createElement('button', {
      className: "team-page--block-list--patient-link",
      type: "button",
      onClick: () => _actions2.default.gotoPatientPage(orgKey, patient.PatientKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}

      ,  getPatientName(patient) || _phone.formatPhoneNumber.call(void 0, patient.Phone) 
    )
  )
}






const BlockedMessagesCell = ({ block, onOpen }) => {
  if (!block.BlockedMessageCount) {
    return _react2.default.createElement('span', { className: "team-page--block-list--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, "No texts" )
  }

  return (
    _react2.default.createElement('button', {
      className: "team-page--block-list--messages-btn",
      type: "button",
      onClick: () => onOpen(block), __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}

      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}},  block.BlockedMessageCount , " text" ,  block.BlockedMessageCount === 1 ? '' : 's' )
      ,  block.LatestBlockedMessageAt && (
        _react2.default.createElement('span', { className: "team-page--block-list--messages-latest", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}, "Last "
           ,  formatLatestBlockedMessageAt(block.LatestBlockedMessageAt) 
        )
      )
    )
  )
}

const BlockListTab = ({ orgKey, teamKey }) => {
  const [blocks, setBlocks] = _react.useState([])
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const [removingPhoneNumber, setRemovingPhoneNumber] = _react.useState.call(void 0, '')
  const [selectedMessagesBlock, setSelectedMessagesBlock] = _react.useState(null)
  const {
    isOpen: isAddBlockModalOpen,
    onOpen: onOpenAddBlockModal,
    onClose: onCloseAddBlockModal,
  } = _useToggle2.default.call(void 0, )
  const {
    isOpen: isBlockedMessagesModalOpen,
    onOpen: onOpenBlockedMessagesModal,
    onClose: onCloseBlockedMessagesModal,
  } = _useToggle2.default.call(void 0, )

  const { showWarningBar, showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  const nameOf = _useUserNameOf2.default.call(void 0, )

  const loadBlocks = _react.useCallback.call(void 0, 
    () => {
      setIsLoading(true)
      return _actions2.default.getPhoneNumberBlocks({ OrgKey: orgKey, TeamKey: teamKey })
        .then(({ Blocks }) => setBlocks(Blocks))
        .catch(() => showWarningBar('Failed to load blocked phone numbers'))
        .finally(() => setIsLoading(false))
    },
    [orgKey, teamKey, showWarningBar],
  )

  _react.useEffect.call(void 0, () => {
    loadBlocks()
  }, [loadBlocks])

  const onAddBlock = _react.useCallback.call(void 0, 
    (phoneNumber) => _actions2.default.addPhoneNumberBlock({
      OrgKey: orgKey,
      TeamKey: teamKey,
      PhoneNumber: phoneNumber,
    })
      .then(({ Blocks }) => {
        setBlocks(Blocks)
        showSuccessBar('Phone number blocked')
      })
      .catch(error => {
        showWarningBar('Failed to block phone number')
        throw error
      }),
    [orgKey, teamKey, showSuccessBar, showWarningBar],
  )

  const onRemoveBlock = _react.useCallback.call(void 0, 
    (phoneNumber) => {
      setRemovingPhoneNumber(phoneNumber)
      return _actions2.default.removePhoneNumberBlock({
        OrgKey: orgKey,
        TeamKey: teamKey,
        PhoneNumber: phoneNumber,
      })
        .then(({ Blocks }) => {
          setBlocks(Blocks)
          showSuccessBar('Phone number unblocked')
        })
        .catch(() => showWarningBar('Failed to unblock phone number'))
        .finally(() => setRemovingPhoneNumber(''))
    },
    [orgKey, teamKey, showSuccessBar, showWarningBar],
  )

  const onOpenBlockedMessages = _react.useCallback.call(void 0, 
    (block) => {
      setSelectedMessagesBlock(block)
      onOpenBlockedMessagesModal()
    },
    [onOpenBlockedMessagesModal],
  )

  const onCloseBlockedMessages = _react.useCallback.call(void 0, 
    () => {
      onCloseBlockedMessagesModal()
      setSelectedMessagesBlock(null)
    },
    [onCloseBlockedMessagesModal],
  )

  return (
    _react2.default.createElement(_components.TabFrame, {
      preview: (
        _react2.default.createElement(_SmsPreview.SmsPhone, { isThread: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}
          , _react2.default.createElement(_SmsPreview.SmsBubble, { side: "patient", className: "team-page--sample-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}},  _components.SAMPLE_TEXT )
          , _react2.default.createElement('div', { className: "team-page--block-list--undelivered", __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}, "Not delivered to your inbox"    )
        )
      ),
      caption: "Texts from a blocked number never reach the inbox. Open the texts link on a row to read them."                  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}

      , _react2.default.createElement('div', { className: "team-page--card team-page--card--head team-page--block-list"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
        , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}
          , _react2.default.createElement('div', { className: "team-page--card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}, "Blocked numbers" )
          , _react2.default.createElement('div', { className: "team-page--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}},  _smsDelivery.SMS_BLOCK_LIST_HEADING )
        )
        , _react2.default.createElement(_Form.Button, { onClick: onOpenAddBlockModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}, "+ Block a number"   )
      )
      ,  isLoading && (
        _react2.default.createElement('div', { className: "team-page--card team-page--muted" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}, "Loading blocked phone numbers..."   )
      )
      ,  !isLoading && !blocks.length && (
        _react2.default.createElement('div', { className: "team-page--card team-page--muted" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}, "No blocked phone numbers"   )
      )
      ,  !isLoading && blocks.map(block => {
        const view = _smsDelivery.describePhoneNumberBlock.call(void 0, block, nameOf(block.CreatedBy))
        const canUnblock = _smsDelivery.phoneNumberBlockClearAction.call(void 0, block) === 'RemovePhoneNumberBlock'
        const number = _phone.formatPhoneNumber.call(void 0, block.BlockedPhoneNumber) || block.BlockedPhoneNumber
        return (
          _react2.default.createElement('div', {
            key: `${block.BlockedPhoneNumber}-${block.Reason}`,
            className: "team-page--card team-page--block-list--item" ,
            'data-testid': "block-list-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}}

            , _react2.default.createElement('span', { className: "team-page--block-list--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}, "⛔")
            , _react2.default.createElement('div', { className: "team-page--block-list--main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
              , _react2.default.createElement('div', { className: "team-page--card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}},  number )
              , _react2.default.createElement('div', { className: "team-page--block-list--meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 212}},  view.label )
                , _react2.default.createElement(LinkedPatientCell, { orgKey: orgKey, patients: block.LinkedPatients || [], __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}} )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 214}},  view.detail )
                ,  !!view.note && _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 215}},  `"${view.note}"` ) 
              )
            )
            , _react2.default.createElement(BlockedMessagesCell, { block: block, onOpen: onOpenBlockedMessages, __self: this, __source: {fileName: _jsxFileName, lineNumber: 218}} )
            ,  canUnblock && (
              _react2.default.createElement('button', {
                className: "team-page--block-list--remove-btn",
                disabled: removingPhoneNumber === block.BlockedPhoneNumber,
                type: "button",
                'aria-label': `Unblock ${number}`,
                onClick: () => onRemoveBlock(block.BlockedPhoneNumber), __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}
, "Unblock"

              )
            )
          )
        )
      })
      , _react2.default.createElement(_AddBlockModal2.default, {
        isOpen: isAddBlockModalOpen,
        onClose: onCloseAddBlockModal,
        onProceed: onAddBlock, __self: this, __source: {fileName: _jsxFileName, lineNumber: 233}}
      )
      , _react2.default.createElement(_BlockedMessagesModal2.default, {
        block: selectedMessagesBlock,
        isOpen: isBlockedMessagesModalOpen,
        onClose: onCloseBlockedMessages,
        orgKey: orgKey,
        teamKey: teamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
      )
    )
  )
}

exports. default = BlockListTab
